import { useState, useEffect } from "react";

/** Breakpoints: phone < 768 ≤ tablet < 1100 ≤ desktop. (mirrors Mobile App) */
export function useBreakpoint() {
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const on = () => setWidth(window.innerWidth);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  const isWide = width >= 768;
  const isDesktop = width >= 1100;
  return { width, isWide, isDesktop, columns: isDesktop ? 3 : isWide ? 2 : 1 };
}
